import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../abstraction/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataLayerService } from '../../../services/utils/data-layer.service';
import { TransactionType } from '../../../models/Transactions';
import { DOCUMENT_STATUS } from '../../../models/User';

// enum DEPOSIT_TYPE {
//   DOLAR = 0,
//   PESOS = 1,
//   CRYPTO = 2,
// }

@Component({
  selector: 'app-deposit-tab',
  templateUrl: './deposit-tab.component.html',
  styleUrls: ['./deposit-tab.component.scss'],
})
export class DepositTabComponent implements OnInit {
  depositSelected: number;
  quickStep: number;
  loading: boolean;
  amount: string;
  depositType: number;
  depositStep: number;
  isDepositDisabled = false;
  monthLimit: number;
  DOCUMENT_STATUS = DOCUMENT_STATUS;
  constructor(
    public dialogRef: MatDialogRef<DepositTabComponent>,
    public apiService: ApiService,
    public authService: AuthService,
  ) {}

  ngOnInit() {
    this.depositStep = 0;
    this.depositType = null;
    this.authService.refreshFiatStatus();
    this.authService.getFiatStatus().subscribe((res) => {
      this.isDepositDisabled = !res.find((status) => {
        return status.type === TransactionType.DEPOSIT;
      })?.coins[this.depositSelected === 1 ? 'ARS' : 'USD'];
    });
    this.getLimits();
    if (
      this.authService.loggedUser.externalFlags?.maybePEP ||
      this.authService.loggedUser.externalFlags?.maybeTerrorist ||
      this.authService.loggedUser.externalFlags?.isTerrorist ||
      (this.authService.loggedUser.externalFlags?.isPEP &&
        this.authService.loggedUser.data.pepDoc !== DOCUMENT_STATUS.VALIDATED)
    ) {
      this.authService.getMe();
    }
  }

  funx = (data) => {
    this.quickStep = 2;
  };

  back() {
    this.depositStep -= 1;
  }

  getLimits() {
    this.apiService.getUserLimits().subscribe((res) => {
      this.monthLimit = res.monthLimit;
    });
  }
}
